import React from 'react';

const NoPage = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <h2 className="text-xl">Error 404: Not found</h2>
    </div>
  );
}

export default NoPage;
